export const SET_PUZZLE = 'SET_PUZZLE'
export const KEY_PRESS = 'KEY_PRESS'
export const UPDATE_ALPHABET = 'UPDATE_ALPHABET'
export const UPDATE_STATUS_MESSAGE = 'UPDATE_STATUS_MESSAGE'
export const SET_CURRENT_LETTER = 'SET_CURRENT_LETTER'
export const SET_CURRENT_NUMBER_OF_CORRECT_LETTERS = 'SET_CURRENT_NUMBER_OF_CORRECT_LETTERS'
export const SAVE_GAME_TO_DATABASE = 'SAVE_GAME_TO_DATABASE'

export const SET_GAMES_PLAYED = 'SET_GAMES_PLAYED'
export const FETCH_GAMES_START = 'FETCH_GAMES_START'
export const FETCH_GAMES_SUCCESS = 'FETCH_GAMES_SUCCESS'
export const FETCH_GAMES = 'FETCH_GAMES'